import { Directive, Input, ElementRef, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'img[defaultImage]',
})
export class DefaultImageDirective {
  @Input('defaultImage')
  public defaultImage: any;

  element: HTMLElement;

  @HostListener('error')
  onError() {
    this.updateUrl();
  }

  constructor(private elementRef: ElementRef) {
    this.element = elementRef.nativeElement;
  }

  private updateUrl() {
    this.element.setAttribute('src', this.defaultImage);
  }
}
